import { useEffect, useState } from "react";
import { initKeycloak } from "./keycloakInit";
import Appv2 from "../Appv2";

const Auth = () => {
  const [keycloak, setKeycloak] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    document.title = "Judumo Portalas";

    const initAuth = async () => {
      const kc = await initKeycloak();
      if (kc) {
        setKeycloak(kc);
        setLoading(false);
      }
    };

    initAuth();
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!keycloak || !keycloak.authenticated) {
    return (
      <div style={{ textAlign: "center", marginTop: "50px" }}>
        <h1>Judumo Portalas</h1>
        <button onClick={() => keycloak?.login()}>
          Sign In With Keycloak
        </button>
      </div>
    );
  }

  return <Appv2 keycloak={keycloak} />;
};

export default Auth;
